import { render, staticRenderFns } from "./general-shipments-calendar-modal.vue?vue&type=template&id=77efa88e&scoped=true"
import script from "./general-shipments-calendar-modal.vue?vue&type=script&lang=js"
export * from "./general-shipments-calendar-modal.vue?vue&type=script&lang=js"
import style0 from "./general-shipments-calendar-modal.vue?vue&type=style&index=0&id=77efa88e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77efa88e",
  null
  
)

export default component.exports